<template>
    <AppLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Board Settings
            </h2>
        </template>

        <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
            <div>
                <edit-basic :board="$page.board" :errors="$page.errors"></edit-basic>
            </div>

            <div class="hidden sm:block">
                <div class="py-5">
                    <div class="border-t border-gray-200"></div>
                </div>
            </div>

            <div class="mt-10 sm:mt-0">
                <edit-private-posting :board="$page.board" :errors="$page.errors"></edit-private-posting>
            </div>

            <div class="hidden sm:block">
                <div class="py-5">
                    <div class="border-t border-gray-200"></div>
                </div>
            </div>

            <div class="mt-10 sm:mt-0">
                <edit-categories :categories="categories" :errors="$page.errors"></edit-categories>
            </div>

            <div class="hidden sm:block">
                <div class="py-5">
                    <div class="border-t border-gray-200"></div>
                </div>
            </div>

            <div class="mt-10 sm:mt-0">
                <edit-menu-links :menuLinks="menuLinks" :errors="$page.errors"></edit-menu-links>
            </div>

            <div class="hidden sm:block">
                <div class="py-5">
                    <div class="border-t border-gray-200"></div>
                </div>
            </div>

            <div class="mt-10 sm:mt-0">
                <edit-products :products="products" :supportedCurrencies="supportedCurrencies" :errors="$page.errors"></edit-products>
            </div>

            <div class="hidden sm:block">
                <div class="py-5">
                    <div class="border-t border-gray-200"></div>
                </div>
            </div>

            <div class="mt-10 sm:mt-0">
                <edit-stripe :url="stripeConnectUrl" :connected="stripeConnected"></edit-stripe>
            </div>

            <div class="hidden sm:block">
                <div class="py-5">
                    <div class="border-t border-gray-200"></div>
                </div>
            </div>

            <div class="mt-10 sm:mt-0">
                <edit-analytics :gaTrackingId="gaTrackingId" :errors="$page.errors"></edit-analytics>
            </div>

            <div class="hidden sm:block">
                <div class="py-5">
                    <div class="border-t border-gray-200"></div>
                </div>
            </div>

            <div class="mt-10 sm:mt-0">
                <edit-contact-email :board="$page.board" :userEmail="userEmail" :errors="$page.errors"></edit-contact-email>
            </div>
        </div>
    </AppLayout>
</template>

<script>
    import EditBasic from "@/Pages/Publisher/Settings/EditBasic";
    import EditCategories from "@/Pages/Publisher/Settings/EditCategories";
    import EditStripe from "@/Pages/Publisher/Settings/EditStripe";
    import EditAnalytics from "@/Pages/Publisher/Settings/EditAnalytics";
    import EditProducts from "@/Pages/Publisher/Settings/EditProducts";
    import EditPrivatePosting from "@/Pages/Publisher/Settings/EditPrivatePosting";
    import AppLayout from "@/Layouts/AppLayout";
    import EditMenuLinks from "./EditMenuLinks";
    import EditContactEmail from "./EditContactEmail";

    export default {
        components: {
            EditMenuLinks,
            AppLayout,
            EditProducts,
            EditBasic,
            EditCategories,
            EditStripe,
            EditAnalytics,
            EditPrivatePosting,
            EditContactEmail
        },
        props: {
            categories: Array,
            stripeConnectUrl: String,
            stripeConnected: Boolean,
            gaTrackingId: String,
            products: Array,
            menuLinks: Array,
            userEmail: String,
            supportedCurrencies: Array
        },
        metaInfo: {title: 'Settings'},
        name: "Edit",
    }
</script>
